import axiosClient, { axiosClientV2 } from './axios.client';

/** Python connector routes via Node's authenticated proxy (adds the tenant identity for live tests). */
const PYTHON_VIA_NODE = 'langgraph-proxy/api/v1/';

export async function listConnectors() {
  try {
    const data = await axiosClient.get(`${PYTHON_VIA_NODE}connectors`);
    return { connectors: Array.isArray(data) ? data : [], error: null };
  } catch (err) {
    return { connectors: [], error: err?.message || 'Failed to load connectors' };
  }
}

/** Tenant credential refs (names only; secrets are write-only). */
export async function listConnectorCredentials() {
  try {
    const data = await axiosClientV2.get('connector-credentials');
    return { credentials: Array.isArray(data?.credentials) ? data.credentials : [], error: null };
  } catch (err) {
    return { credentials: [], error: err?.message || 'Failed to load connector credentials' };
  }
}

export async function saveConnectorCredential(ref, credential) {
  try {
    const {
      connectorId, authType, label, secret, header,
    } = credential;
    const data = await axiosClientV2.put(`connector-credentials/${encodeURIComponent(ref)}`, {
      connectorId, authType, label, secret, ...(header ? { header } : {}),
    });
    return { credential: data?.credential || null, error: null };
  } catch (err) {
    return { credential: null, error: err?.message || 'Failed to save credential' };
  }
}

export async function deleteConnectorCredential(ref) {
  try {
    await axiosClientV2.delete(`connector-credentials/${encodeURIComponent(ref)}`);
    return { error: null };
  } catch (err) {
    return { error: err?.message || 'Failed to delete credential' };
  }
}

/** Runs the connector's read-only check with a stored credential; the result is saved as lastTest. */
export async function testConnectorCredential(ref, { url } = {}) {
  try {
    const data = await axiosClientV2.post(`connector-credentials/${encodeURIComponent(ref)}/test`, url ? { url } : {});
    return { test: data?.test || null, credential: data?.credential || null, error: null };
  } catch (err) {
    return { test: null, credential: null, error: err?.message || 'Connection test failed' };
  }
}

export async function testConnector(payload) {
  try {
    const data = await axiosClient.post(`${PYTHON_VIA_NODE}connectors/test`, payload);
    return { result: data, error: null };
  } catch (err) {
    return { result: null, error: err?.message || 'Connector test failed' };
  }
}
